import { put, takeLatest, select } from 'redux-saga/effects';
import { fetchDashboardAvailableTasks, appNotify, setDashboardAvailableTasks, setAvailableTasksIsLoading } from 'store/actions';
import { postWithToken } from 'api/network';
import { dashboardFilterSelector } from 'store/selectors';

export function* getDashboardAvailableTasksSaga() {
  yield takeLatest(fetchDashboardAvailableTasks, function* ({ payload }) {
    try {
      yield put(setAvailableTasksIsLoading(true));

      var filter = yield select(dashboardFilterSelector);
      const data = {
        channels: payload.channels,
        userIds: payload.selectedUsers,
        loadOptions: {
          select: ["ChannelText","OpportunityStatus"],
          remoteSelect: true,
          filter: filter,
          group: [
            { "selector": "ChannelText", "desc": false, "isExpanded": false },
            { "selector": "OpportunityStatus", "desc": false, "isExpanded": false }
          ]
        }
      }

      const dashboardTasks = [];
      const url = `/api/dashboard/getDashboardAvailableTasks`;
      yield postWithToken(url, data )
        .then(response => response.json())
        .then((data) => {
          data.data.forEach((group) => {
            group.items.forEach((item) => {
              const task = {channel: group.key, dashboardTaskType: item.key ?? "Incomplete", count: item.count};
              dashboardTasks.push(task);
            }) 
          })
        });

      console.log(`${payload.channels} available tasks: `, dashboardTasks);

      yield put(setAvailableTasksIsLoading(false));
      yield put(setDashboardAvailableTasks({dashboardAvailableTasks: dashboardTasks}));
    } catch (error) {
      yield put(setAvailableTasksIsLoading(false));
      yield put(appNotify(`Failed to fetch dashboard available tasks: ${error.message}`, 'error'));
    }
  });
}
